export const getCellStyle = (size: number | string, isCentered = false) => ({
  ...(size.toString().endsWith('px') ? { width: size, flex: 'none' } : { flex: size }),
  display: 'flex',
  justifyContent: isCentered ? 'center' : 'flex-start',
})
